/**
 * Approved photography.
 *
 * Only client-supplied, approved images go here. Anything still pending stays empty
 * and the UI falls back to a clearly labeled placeholder block.
 *
 * Never apply a color overlay, duotone, gradient scrim, or heavy filter to these photos.
 */

/** Hero — Gabriela + Chanira. Pending the approved horizontal, natural-daylight shot. */
export const HERO_PHOTO = ''

/**
 * The single shared photo of both Queens.
 * Gabriela is on the LEFT (blonde). Chanira is on the RIGHT (dark curly hair).
 */
export const QUEENS_PHOTO = 'https://cdn.magicpatterns.com/uploads/uRPXDd1yZEaEpBMViyF5UN/image.png'

/**
 * Focal points used to crop the shared photo down to each Queen in the QueenPicker,
 * so no separate portrait file is needed.
 */
export const QUEEN_FOCUS = {
  Gabriela: '38% 42%',
  Chanira: '66% 42%',
} as const

/** Closing block photo — pending. */
export const FINAL_PHOTO = ''
